import React, {Component} from "react";
import Moment from "moment";
import fields from "../../theme/tables/fields.json";

let MetricFields = fields['canvassers'];
delete MetricFields['id']
delete MetricFields['name']
MetricFields = Object.values(MetricFields);
// console.log("MetricFields", MetricFields)

class CanvasserSideBarItem extends Component {

    renderValue(field) {
        let val = this.props.data[field.field];
        if (!val) {
            return null;
        }

        if (field.type === 'time') {
            return new Moment(val).format("LT");
        } else if (field.type === 'object') {
            return JSON.stringify(val)
        }
        return val;
    }

    render() {
        let {data, focused, id} = this.props;

        return (
            <div

                className={`side-menu-list-obj ${focused && "focused"}`}
                onMouseEnter={this.props.onMouseEnter}
                onMouseLeave={this.props.onMouseLeave}
                id={`sidebar-canvasser-${data.canvasser_id}`}
                onClick={this.props.onTitleClick}
            >
                <div
                    className="list-obj-inner-wrapper"
                >
                    <div className="obj-title" onClick={this.props.onTitleClick}>
            <span
                className={"fa fa-user"}
                style={{fontSize: 10, marginRight: 5}}
            />
                        {data.canvasser_name}
                    </div>
                    {this.props.showTimes && MetricFields.map((field) => {
                        const val = this.renderValue(field);
                        if (!val) return val;
                        return <div key={`${data.canvasser_id}-${field.field}`} className="obj-data">
                            {field.headerName}: <b>{val}</b>
                        </div>
                    })
                    }
                </div>
            </div>
        );
    }
}

export default CanvasserSideBarItem;
